import Axios from 'axios';

const axios = Axios.create({
    baseURL: '/',
    headers: {
        Accept: 'application/json',
        "Content-Type": 'application/json',
        "X-CSRF-Token": window.csrfToken
    }
});

export default axios
